var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MyRequest',{attrs:{"from-home":_vm.fromHome,"open-directly":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }